import { Text } from '@eo-locale/react';
import { FC, useState } from 'react';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { AuthApi } from '../../api';
import { useAuthContext } from '../../hooks';
import { Button, CodeField } from '../atoms';
import type { LoginFormFields } from './LoginForm';
import styles from './LoginForm.module.css';

export const LoginCodeStep: FC = () => {
  const { signIn } = useAuthContext();
  const { handleSubmit, watch, setError, setValue } = useFormContext<LoginFormFields>();
  const membershipId = watch('membershipId');
  const code = watch('code');
  const [loading, setLoading] = useState(false);

  const onSubmit: SubmitHandler<LoginFormFields> = async ({ code, membershipId }) => {
    try {
      setLoading(true);
      const { access_token } = await AuthApi.loginByCode(membershipId, code);
      if (!access_token) throw new Error('Brak access_token w odpowiedzi');

      await signIn(access_token, { navigate: true });
    } catch (error) {
      setValue('code', '');
      setError('code', { type: 'validate' });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    try {
      await AuthApi.requestOtp(membershipId);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
      <CodeField />
      <div>
        <Button className={styles.submit} disabled={loading || !code?.length}>
          {loading ? <Text id="login:loading" defaultMessage="Loguję..." /> : <Text id="login:submit" />}
        </Button>
        <button className={styles.resend} type="button" onClick={resend} disabled={loading}>
          <Text id="login:resend_code" />
        </button>
      </div>
    </form>
  );
};